import TecnicoEmailService from "@/services/TecnicoEmailService";

export const tecnicoEmail = {
  namespaced: true,
  state: {
    tecnicoEmail: {},
  },
  actions: {
    getTecnicoEmail({ commit }, payload) {
      return TecnicoEmailService.GetTecnicoEmail(payload).then(
        (tecnicoEmail) => {
          return Promise.resolve(tecnicoEmail);
        },
        (error) => {
          return Promise.reject(error.response.data);
        }
      );
    },
    postTecnicoEmail({ commit }, payload) {
      return TecnicoEmailService.PostTecnicoEmail(payload).then(
        (tecnicoEmail) => {
          return Promise.resolve(tecnicoEmail);
        },
        (error) => {
          return Promise.reject(error.response.data);
        }
      );
    },
    putTecnicoEmail({ commit }, payload) {
      return TecnicoEmailService.PutTecnicoEmail(payload).then(
        (tecnicoEmail) => {
          return Promise.resolve(tecnicoEmail);
        },
        (error) => {
          return Promise.reject(error.response.data);
        }
      );
    },
    deleteTecnicoEmail({ commit }, payload) {
      return TecnicoEmailService.DeleteTecnicoEmail(payload).then(
        (response) => {
          return Promise.resolve(response);
        },
        (error) => {
          return Promise.reject(error.response.data);
        }
      );
    },
    getTecnicoEmailOData({ commit }, payload) {
      return TecnicoEmailService.GetTecnicoEmailOData(payload).then(
        (tecnicoEmail) => {
          return Promise.resolve(tecnicoEmail);
        },
        (error) => {
          return Promise.reject(error);
        }
      );
    },
  },
  mutations: {},
};

export default tecnicoEmail;
